import posthog from 'posthog-js'

// PostHog project: MicroPlastics Web (US cloud, project 579748).
// Project tokens are public browser identifiers, not secrets. Environment
// variables can override these defaults without requiring a code change.
const posthogToken =
  process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN ??
  'phc_mcxRbvF6PzbN6DDe8Hjf39DtAnARzzRwuzkMQYedd8UT'
const posthogHost =
  process.env.NEXT_PUBLIC_POSTHOG_HOST ?? 'https://us.i.posthog.com'

posthog.init(posthogToken, {
  api_host: posthogHost,
  defaults: '2026-05-30',
  capture_pageview: true,
  capture_pageleave: true,
  autocapture: true,
  // Heatmaps require coordinate capture in addition to autocapture. This
  // powers click, movement, and scroll maps without exposing form values;
  // replay input masking remains enabled below.
  enable_heatmaps: true,
  capture_exceptions: true,
  // Keep replay activation explicit in the client. Project-side privacy,
  // sampling, domain, and retention controls still apply remotely.
  disable_session_recording: false,
  // Keep form values and other potentially sensitive input out of replays.
  session_recording: {
    maskAllInputs: true,
  },
})
